import "./src/styles/assets/css/responsive.css"
import "./src/styles/assets/css/style.css"
// import "./src/styles/assets/css/style.css.map"

import "./src/styles/assets/css/vendor/animate.css"
import "./src/styles/assets/css/vendor/bootstrap.min.css"
import "./src/styles/assets/css/vendor/flaticon.css"
import "./src/styles/assets/css/vendor/font-awesome.min.css"
import "./src/styles/assets/css/vendor/jquery-ui.min.css"
import "./src/styles/assets/css/vendor/lightbox.css"
import "./src/styles/assets/css/vendor/owl.carousel.min.css"
import "./src/styles/assets/css/vendor/owl.theme.default.min.css"

import "./src/styles/assets/css/vendor/fonts/flexslider-icon.eot"
import "./src/styles/assets/css/vendor/fonts/flexslider-icon.svg"
import "./src/styles/assets/css/vendor/fonts/flexslider-icon.ttf"
import "./src/styles/assets/css/vendor/fonts/flexslider-icon.woff"

import "./src/styles/assets/css/vendor/fonts/revicons/index.php"
import "./src/styles/assets/css/vendor/fonts/revicons/revicons.eot"
import "./src/styles/assets/css/vendor/fonts/revicons/revicons.svg"
import "./src/styles/assets/css/vendor/fonts/revicons/revicons.ttf"
// import "./src/styles/assets/css/vendor/fonts/revicons/revicons.wof"

import "./src/styles/assets/favicon/apple-icon-57x57.png"
import "./src/styles/assets/favicon/apple-icon-72x72.png"
import "./src/styles/assets/favicon/apple-icon-114x114.png"
import "./src/styles/assets/favicon/apple-icon-144x144.png"

import "./src/styles/assets/fonts/fontawesome-webfont.eot"
import "./src/styles/assets/fonts/fontawesome-webfont.svg"
import "./src/styles/assets/fonts/fontawesome-webfont.ttf"
import "./src/styles/assets/fonts/fontawesome-webfont.woff"
import "./src/styles/assets/fonts/fontawesome-webfont.woff2"

import "./src/styles/assets/fonts/flaticon/Flaticon.eot"
import "./src/styles/assets/fonts/flaticon/Flaticon.svg"
import "./src/styles/assets/fonts/flaticon/Flaticon.ttf"
import "./src/styles/assets/fonts/flaticon/Flaticon.woff"

import "./src/styles/assets/img/up.png"

// import "./src/styles/assets/img/bg/5.jpg"
// import "./src/styles/assets/img/bg/6.jpg"
// import "./src/styles/assets/img/bg/7.jpg"
// import "./src/styles/assets/img/bg/9.jpg"
import "./src/styles/assets/img/bg/footer.jpg"
// import "./src/styles/assets/img/bg/skyline-bg.png"


import "./src/styles/assets/img/bg-dimensions/404.jpg"
import "./src/styles/assets/img/bg-dimensions/footer.jpg"

// import "./src/styles/assets/img/blog/1.jpg"
// import "./src/styles/assets/img/blog/2.jpg"
// import "./src/styles/assets/img/blog/3.jpg"
// import "./src/styles/assets/img/blog/4.jpg"
// import "./src/styles/assets/img/blog/5.jpg"
// import "./src/styles/assets/img/blog/6.jpg"
// import "./src/styles/assets/img/blog/7.jpg"
// import "./src/styles/assets/img/blog/8.jpg"
// import "./src/styles/assets/img/blog/9.jpg"
// import "./src/styles/assets/img/blog/10.jpg"
// import "./src/styles/assets/img/blog/11.jpg"

// import "./src/styles/assets/img/conference/1.jpg"
// import "./src/styles/assets/img/conference/2.jpg"
// import "./src/styles/assets/img/conference/3.jpg"
// import "./src/styles/assets/img/conference/4.jpg"


import "./src/styles/assets/img/lightbox/close.png"
import "./src/styles/assets/img/lightbox/loading.gif"
import "./src/styles/assets/img/lightbox/next.png"
import "./src/styles/assets/img/lightbox/prev.png"

import "./src/styles/assets/img/logo/logo-2-dimensions.png"
import "./src/styles/assets/img/logo/logo-2.png"
import "./src/styles/assets/img/logo/logo-3.png"
import "./src/styles/assets/img/logo/logo.png"

import "./src/styles/assets/img/mockup/man.png"
import "./src/styles/assets/img/mockup/vector-2.png"
import "./src/styles/assets/img/mockup/vector.png"

// import "./src/styles/assets/img/others/1.png"
// import "./src/styles/assets/img/others/2.png"
// import "./src/styles/assets/img/others/3.png"
// import "./src/styles/assets/img/others/4.png"
// import "./src/styles/assets/img/others/5.png"
import "./src/styles/assets/img/others/element.png"

// import "./src/styles/assets/img/pricing/1.png"
// import "./src/styles/assets/img/pricing/2.png"
// import "./src/styles/assets/img/pricing/3.png"

// import "./src/styles/assets/img/shopping/1.jpg"
// import "./src/styles/assets/img/shopping/2.jpg"
// import "./src/styles/assets/img/shopping/4.jpg"
// import "./src/styles/assets/img/shopping/3.jpg"
// import "./src/styles/assets/img/shopping/5.jpg"
// import "./src/styles/assets/img/shopping/6.jpg"
// import "./src/styles/assets/img/shopping/7.jpg"
// import "./src/styles/assets/img/shopping/9.jpg"
// import "./src/styles/assets/img/shopping/10.jpg"
// import "./src/styles/assets/img/shopping/11.jpg"
// import "./src/styles/assets/img/shopping/12.jpg"
// import "./src/styles/assets/img/shopping/13.jpg"
// import "./src/styles/assets/img/shopping/14.jpg"

// import "./src/styles/assets/img/slide/1.jpg"
// import "./src/styles/assets/img/slide/2.jpg"
// import "./src/styles/assets/img/slide/3.jpg"
// import "./src/styles/assets/img/slide/4.jpg"

// import "./src/styles/assets/img/sponsors/1.png"
// import "./src/styles/assets/img/sponsors/2.png"
// import "./src/styles/assets/img/sponsors/3.png"
// import "./src/styles/assets/img/sponsors/4.png"
// import "./src/styles/assets/img/sponsors/5.png"
// import "./src/styles/assets/img/sponsors/6.png"
// import "./src/styles/assets/img/sponsors/7.png"
// import "./src/styles/assets/img/sponsors/8.png"
// import "./src/styles/assets/img/sponsors/9.png"
// import "./src/styles/assets/img/sponsors/10.png"
// import "./src/styles/assets/img/sponsors/11.png"
// import "./src/styles/assets/img/sponsors/12.png"
// import "./src/styles/assets/img/sponsors/13.png"
// import "./src/styles/assets/img/sponsors/14.png"
// import "./src/styles/assets/img/sponsors/15.png"
// import "./src/styles/assets/img/sponsors/16.png"
// import "./src/styles/assets/img/sponsors/17.png"
import "./src/styles/assets/img/sponsors/Refactr _Prospectus_2019.pdf"

// import "./src/styles/assets/img/team/1.jpg"
// import "./src/styles/assets/img/team/2.jpg"
// import "./src/styles/assets/img/team/3.jpg"
// import "./src/styles/assets/img/team/4.jpg"
// import "./src/styles/assets/img/team/5.jpg"
// import "./src/styles/assets/img/team/6.jpg"
// import "./src/styles/assets/img/team/7.jpg"
// import "./src/styles/assets/img/team/8.jpg"
// import "./src/styles/assets/img/team/9.jpg"
// import "./src/styles/assets/img/team/10.jpg"
import "./src/styles/assets/img/team/atl-black-tech.jpg"

import "./src/styles/assets/img/team/organizers/angel.jpg"
import "./src/styles/assets/img/team/organizers/beth.jpg"
import "./src/styles/assets/img/team/organizers/erica.jpg"

// import "./src/styles/assets/img/testimonial/1.jpg"

import "./src/styles/assets/img/workshops/cypress.png"
import "./src/styles/assets/img/workshops/flutter.png"
import "./src/styles/assets/img/workshops/gatsby.png"
import "./src/styles/assets/img/workshops/graphql.png"
import "./src/styles/assets/img/workshops/vue-vixens.png"

// import "./src/styles/assets/php/contact-form.php"

// import "./src/styles/assets/js/main.js"
// import "./src/styles/assets/js/vendor/bootstrap.min.js"
// import "./src/styles/assets/js/vendor/contact.js"
// import "./src/styles/assets/js/vendor/countdown.js"
// import "./src/styles/assets/js/vendor/isotope.pkgd.min.js"
// import "./src/styles/assets/js/vendor/jquery-3.2.1.min.js"
// import "./src/styles/assets/js/vendor/jquery-migrate.js"
// import "./src/styles/assets/js/vendor/jquery-ui.min.js"
// import "./src/styles/assets/js/vendor/jquery.appear.js"
// import "./src/styles/assets/js/vendor/jquery.counterup.min.js"
// import "./src/styles/assets/js/vendor/jquery.easing.1.3.min.js"
// import "./src/styles/assets/js/vendor/lightbox.js"
import "./src/styles/assets/js/vendor/map.js"
// import "./src/styles/assets/js/vendor/modernizr-2.8.3.min.js"
// import "./src/styles/assets/js/vendor/owl.carousel.min.js"
// import "./src/styles/assets/js/vendor/plugins.js"
// import "./src/styles/assets/js/vendor/popper-1.12.9.min.js"
// import "./src/styles/assets/js/vendor/validator.min.js"
// import "./src/styles/assets/js/vendor/waypoints-jquery.js"
// import "./src/styles/assets/js/vendor/wow.min.js"

// import "./src/styles/assets/scss/responsive.scss"
// import "./src/styles/assets/scss/style.scss"

// import "./src/styles/assets/scss/partials/_element-styles.scss"
// import "./src/styles/assets/scss/partials/_global-styles.scss"
// import "./src/styles/assets/scss/partials/_navbar.scss"
// import "./src/styles/assets/scss/partials/_variable.scss"